import { GoogleAuthProvider, isSignInWithEmailLink, onAuthStateChanged, sendSignInLinkToEmail, signInWithEmailLink, signInWithPopup, signOut, type Unsubscribe, type User } from 'firebase/auth';
import { getFirebaseAuth, initFirebaseAuth } from './firebase';

const pendingEmailKey = 'gc_pending_signin_email';

function getMagicLinkUrl() {
  const baseUrl = new URL(window.location.href);
  baseUrl.hash = '';
  baseUrl.search = '';
  if (!baseUrl.pathname.endsWith('/app.html')) {
    baseUrl.pathname = '/app.html';
  }
  return baseUrl.toString();
}

export async function signInWithMagicLink(email: string) {
  const auth = await initFirebaseAuth();
  await sendSignInLinkToEmail(auth, email, {
    url: getMagicLinkUrl(),
    handleCodeInApp: true,
  });
  window.localStorage.setItem(pendingEmailKey, email);
}

export async function completeMagicLinkSignIn() {
  const auth = await initFirebaseAuth();
  if (!isSignInWithEmailLink(auth, window.location.href)) {
    return null;
  }

  let email = window.localStorage.getItem(pendingEmailKey);
  if (!email) {
    email = window.prompt('Please confirm your email address to finish signing in.') ?? '';
  }

  const result = await signInWithEmailLink(auth, email, window.location.href);
  window.localStorage.removeItem(pendingEmailKey);
  return result.user;
}

export async function signInWithGoogle() {
  const auth = await initFirebaseAuth();
  const provider = new GoogleAuthProvider();
  const result = await signInWithPopup(auth, provider);
  return result.user;
}

export async function signOutUser() {
  const auth = await initFirebaseAuth();
  await signOut(auth);
}

export function getCurrentUser() {
  return getFirebaseAuth().currentUser;
}

export async function getCurrentIdToken(forceRefresh = false) {
  const user = getCurrentUser();
  return user ? user.getIdToken(forceRefresh) : null;
}

export function onAuthStateChange(callback: (user: User | null) => void) {
  let unsubscribe: Unsubscribe = () => {};

  void initFirebaseAuth()
    .then((auth) => {
      unsubscribe = onAuthStateChanged(auth, callback);
    })
    .catch((error) => {
      console.error('Firebase auth init failed:', error);
      callback(null);
    });

  return () => unsubscribe();
}
